module.exports = __webpack_public_path__ + "static/img/saomamaidan.f0583471.jpg";